import {ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-page-table-container',
    templateUrl: './page-table-container.component.html',
    styleUrls: ['./page-table-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageTableContainerComponent implements OnInit {
    @Input() headTitle: string;
    @Input() description: string;
    @Input() width: string;
    @Input() lastPage: number;
    @Input() spinner: boolean;
    @Output() setPage = new EventEmitter();
    @ContentChild('tableActionHead') tableActionHead: TemplateRef<any>;

    constructor() {
    }

    ngOnInit(): void {
    }

}
